import { Fragment } from 'react';
import { useChartContext } from '@shopify/polaris-viz-core';
import styles from './TooltipSeries.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { TooltipSeriesName } from '../TooltipSeriesName/TooltipSeriesName.js';

function TooltipSeries({
  children,
  templateColumnCount = 2,
  name
}) {
  const {
    theme
  } = useChartContext();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [name != null && /*#__PURE__*/jsx(TooltipSeriesName, {
      theme: theme,
      children: name
    }), /*#__PURE__*/jsx("div", {
      className: styles.Series,
      style: {
        gridTemplateColumns: `repeat(${templateColumnCount}, auto)`
      },
      children: children
    })]
  });
}

export { TooltipSeries };
